'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _isObject2 = require('lodash/isObject');

var _isObject3 = _interopRequireDefault(_isObject2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _forEach2 = require('lodash/forEach');

var _forEach3 = _interopRequireDefault(_forEach2);

var _camelCase2 = require('lodash/camelCase');

var _camelCase3 = _interopRequireDefault(_camelCase2);

exports.getVal = getVal;
exports.humpsObj = humpsObj;
exports.default = humps;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getVal(val) {
  if ((0, _isObject3.default)(val)) return humps(val); // eslint-disable-line no-use-before-define
  return val;
}

// keyMap and valueMap at the same time.
function humpsObj(obj) {
  var result = {};
  (0, _forEach3.default)(obj, function (val, key) {
    result[(0, _camelCase3.default)(key)] = getVal(val);
  });
  return result;
}

function humps(node) {
  if ((0, _isArray3.default)(node)) return (0, _map3.default)(node, humps);
  if ((0, _isObject3.default)(node)) return humpsObj(node);
  return node;
}


//////////////////
// WEBPACK FOOTER
// ./~/lodash-humps/lib/lodash-humps.js
// module id = 2
// module chunks = 0 1